import ToggleButton from '@material-ui/lab/ToggleButton';
import styled from 'styled-components';
const StyledPill = styled(ToggleButton)`
  &.MuiToggleButton-root {
    margin: 0px 8px 0px 0px;
    border-radius: 20px;
    text-transform: none;
    height: 24px !important;
    min-width: 72px !important;
    border-color: #7ba2c5 !important;
    border-radius: 16px !important;
    font-family: 'OpenSans-Regular' !important;
    color: #005099;
    line-height: 14px !important;
    outline: none !important;
    border: 1px solid rgba(0, 0, 0, 0.12);
    font-size: 12px;
    box-sizing: border-box;
  }
  &.Mui-selected {
    color: #ffffff !important;
    background-color: #005099 !important;
  }
  &.Mui-disabled {
    color: #efefef !important;
    background-color: #005099 !important;
    opacity: 0.4;
  }

  &.MuiToggleButton-root:hover {
    background-color: #ffffff;
  }
`;
export default StyledPill;